import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=5d23510a&scoped=true&"
import script from "./EditTable.vue?vue&type=script&lang=tsx&"
export * from "./EditTable.vue?vue&type=script&lang=tsx&"
import style0 from "./EditTable.vue?vue&type=style&index=0&id=5d23510a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23510a",
  null
  
)

export default component.exports